import createApiServices from "./createApiServices"

const prefixURL = process.env.REACT_APP_URL_FULFILLMENT ? `${process.env.REACT_APP_URL_FULFILLMENT}/api` : 'https://fulfillment-staging.merchize.com/api'
const api = createApiServices({baseUrl: prefixURL})

export const getListOriginalFiles = (data) => {
    return api.makeAuthRequest({
        url: '/order/production-files/search',
        method: 'POST',
        data,
    })
}

export const updateOriginalFile = (id, data) => {
    return api.makeAuthRequest({
        url: `/order/production-files/${id}`,
        method: 'PUT',
        data,
    })
}

export const deleteOriginalFile = (id) => {
    return api.makeAuthRequest({
        url: `/order/production-files/${id}`,
        method: 'DELETE',
    })
}